import { useRequiredParams } from '@pba/react-router';
import { MemberLayout, MemberPrograms, MemberProgramsHeader } from 'features/users';
import { useGetPathToEntityDetail } from '../../hooks';

const PageMemberPrograms = () => {
  const { memberId } = useRequiredParams<{ memberId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();

  return (
    <MemberLayout header={(member) => <MemberProgramsHeader member={member} />} memberId={memberId}>
      {(member) => (
        <MemberPrograms
          getPathToProgramDetail={(id) => getPathToEntityDetail(id, { entityType: 'program' })}
          member={member}
        />
      )}
    </MemberLayout>
  );
};

export default PageMemberPrograms;
